import { useNotifySubAppOnNavigate } from './useNotifySubAppOnNavigate';
import { useSubAppNavigationListener } from './useSubAppNavigationListener';
export const useNavigationSync = (subAppPath, onContainerNavigate, rootPath) => {
    useSubAppNavigationListener(subAppPath, rootPath);
    useNotifySubAppOnNavigate(onContainerNavigate, rootPath);
};
